import graphqlRequest from "../badgingRequest";
import FETCH_BADGES from "./fetchBadgesGraphql";

// fetches badges for a list of studentIds
// returns 2D array of student's badges
export async function fetchBadges(studentIds) {
  const response = await graphqlRequest(FETCH_BADGES, { studentIds });
  const badges = response.listStudentBadges;
  // if locale is missing, assume EN_US
  for (const badge of badges) {
    if (!badge.locale) badge.locale = "EN_US";
  }
  return badges;
}
